// // components/FingerprintScannerModal.tsx
// import React, { useState, useEffect } from 'react';
// import Button from './button';
// import { Fingerprint, CheckCircle, XCircle, RefreshCw, LogIn, AlertCircle } from 'lucide-react';
// import Swal from 'sweetalert2';
// import axios from 'axios';

// const FingerprintScannerModal2 = ({
//   isOpen,
//   onClose,
//   onScanSuccess,
//   onLoginSuccess,
//   email,
//   mode,
//   userId
// }) => {
//   const [scannerStatus, setScannerStatus] = useState(null);
//   const [scanStatus, setScanStatus] = useState('idle');
//   const [errorMessage, setErrorMessage] = useState('');
//   const [fingerprintData, setFingerprintData] = useState(null);
//   const [scanAttempts, setScanAttempts] = useState(0);
//   const [countdown, setCountdown] = useState(0);

//   const BASE_URL = 'http://localhost:9094';
//   const MAX_SCAN_ATTEMPTS = 3;
//   const SCAN_TIMEOUT = 30; // seconds

//   // Check scanner status when modal opens
//   useEffect(() => {
//     if (isOpen) {
//       checkScannerStatus();
//     }
//   }, [isOpen]);

//   // Countdown timer for scan timeout
//   useEffect(() => {
//     let timer;
//     if (scanStatus === 'scanning' && countdown > 0) {
//       timer = setTimeout(() => setCountdown(countdown - 1), 1000);
//     } else if (countdown === 0 && scanStatus === 'scanning') {
//       handleScanTimeout();
//     }
//     return () => clearTimeout(timer);
//   }, [countdown, scanStatus]);

//   const checkScannerStatus = async () => {
//     try {
//       const response = await fetch(`${BASE_URL}/api/hardware/fingerprint-scanner/get-status`, {
//         method: 'GET',
//         headers: {
//           'accept': 'application/json'
//         }
//       });

//       if (!response.ok) {
//         throw new Error(`Scanner status check failed: ${response.status}`);
//       }

//       const data = await response.json();
//       setScannerStatus(data);

//       if (data.code !== '0000') {
//         setErrorMessage(`Scanner error: ${data.message}`);
//         setScanStatus('error');
//       }
//     } catch (err) {
//       console.error('Scanner status check error:', err);
//       setErrorMessage('Failed to check fingerprint scanner. Please ensure scanner is connected.');
//       setScanStatus('error');
//     }
//   };

//   const scanFingerprint = async () => {
//     if (scanAttempts >= MAX_SCAN_ATTEMPTS) {
//       Swal.fire({
//         icon: 'warning',
//         title: 'Maximum Attempts Reached',
//         text: 'Please try again later or use an alternative method.',
//         confirmButtonColor: '#B03982'
//       });
//       handleClose();
//       return;
//     }

//     setScanStatus('scanning');
//     setCountdown(SCAN_TIMEOUT);
//     setErrorMessage('');

//     try {
//       const response = await fetch(`${BASE_URL}/api/hardware/fingerprint-scanner/scan`, {
//         method: 'POST',
//         headers: {
//           'accept': 'application/json',
//           'Content-Type': 'application/json'
//         }
//       });

//       const data = await response.json();

//       // Check for timeout error (code: 9998)
//       if (data.code === '9998') {
//         setScanAttempts(prev => prev + 1);
//         setScanStatus('error');
//         setErrorMessage(`Scan timeout. ${MAX_SCAN_ATTEMPTS - (scanAttempts + 1)} attempts remaining.`);
//         return;
//       }

//       // Check for success (code: 0000)
//       if (data.code === '0000' && data.data) {
//         setFingerprintData(data.data);
//         setScanStatus('success');

//         // Handle based on mode
//         if (mode === 'registration') {
//           // Call registration handler
//           await handleRegistration(data.data);
//         } else {
//           // Call login handler
//           await handleLogin(data.data);
//         }
//       } else {
//         setScanAttempts(prev => prev + 1);
//         setScanStatus('error');
//         setErrorMessage(`Scan failed: ${data.message || 'Unknown error'}`);
//       }

//     } catch (err) {
//       console.error('Fingerprint scan error:', err);
//       setScanAttempts(prev => prev + 1);
//       setScanStatus('error');
//       setErrorMessage(err.message || 'Failed to scan fingerprint. Please try again.');
//     }
//   };

//   const handleScanTimeout = () => {
//     setScanStatus('error');
//     setErrorMessage(`Scan timed out after ${SCAN_TIMEOUT} seconds. Please try again.`);
//     setScanAttempts(prev => prev + 1);
//   };

//   const handleRegistration = async (fingerprintData) => {
//     try {
//       setScanStatus('processing');

//       // Call your backend API to register fingerprint
//       const registrationResponse = await axios.post(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/biometric/register`, {
//         // userId: userId,
//         type: 'FINGERPRINT',
//         template: fingerprintData.fingerprintWsq || fingerprintData.fingerprintIso,
//         format: fingerprintData.fingerprintWsq ? 'WSQ' : 'ISO',
//         email: email,
//         timestamp: new Date().toISOString()
//       });

//       if (registrationResponse.data.success) {
//         Swal.fire({
//           icon: 'success',
//           title: 'Registration Successful',
//           text: 'Your fingerprint has been registered successfully!',
//           timer: 2000,
//           showConfirmButton: false
//         });

//         onScanSuccess(fingerprintData);
//         setTimeout(() => handleClose(), 2000);
//       } else {
//         throw new Error(registrationResponse.data.message || 'Registration failed');
//       }
//     } catch (err) {
//       console.error('Fingerprint registration error:', err);
//       setScanStatus('error');
//       setErrorMessage(err.message || 'Failed to register fingerprint. Please try again.');
//     }
//   };

//   const handleLogin = async (fingerprintData) => {
//     console.log('fingerprint data ===>', fingerprintData);

//     try {
//       setScanStatus('processing');

//       // Call your backend API to authenticate with fingerprint
//       const loginResponse = await axios.post(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/biometric/authenticate`,
//         {
//           type: 'FINGERPRINT',
//           template: fingerprintData.fingerprintWsq || fingerprintData.fingerprintIso,
//           format: fingerprintData.fingerprintWsq ? 'WSQ' : 'ISO',
//           email: email,
//           timestamp: new Date().toISOString(),
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             token: `${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       const loginData = loginResponse.data.data;

//       if (loginData.success && loginData.user) {
//         const token = loginData.token;

//         Swal.fire({
//           icon: 'success',
//           title: 'Login Successful',
//           text: `Welcome back, ${loginData.user.name || loginData.user.email || 'User'}!`,
//           timer: 2000,
//           showConfirmButton: false
//         });

//         if (onLoginSuccess) {
//           console.log('login data ===>', loginData);
//           onLoginSuccess(token, loginData.user);
//         }

//         onScanSuccess(fingerprintData);
//         setTimeout(() => handleClose(), 2000);
//       } else {
//         throw new Error(loginData.message || 'Authentication failed');
//       }
//     } catch (err) {
//       console.error('Fingerprint login error:', err);
//       setScanStatus('error');

//       if (err.response?.status === 401) {
//         setErrorMessage('Fingerprint not recognized. Please try again.');
//       } else if (err.response?.status === 404) {
//         setErrorMessage('No registered fingerprint found. Please register first.');
//       } else {
//         setErrorMessage(err.response?.data?.message || err.message || 'Failed to authenticate. Please try again.');
//       }
//     }
//   };

//   const handleRetry = () => {
//     setScanStatus('idle');
//     setErrorMessage('');
//     setFingerprintData(null);
//     checkScannerStatus();
//   };

//   const handleClose = () => {
//     setScanStatus('idle');
//     setErrorMessage('');
//     setFingerprintData(null);
//     setScannerStatus(null);
//     setScanAttempts(0);
//     setCountdown(0);
//     onClose();
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg p-6 max-w-md w-full relative">
//         <h2 className="text-xl font-semibold mb-4 text-[#B03982]">
//           {mode === 'registration' ? 'Register Fingerprint' : 'Fingerprint Login'}
//         </h2>

//         <p className="text-gray-600 mb-4">
//           {mode === 'registration'
//             ? 'Place your finger on the scanner to register'
//             : 'Place your finger on the scanner to log in'
//           }
//         </p>

//         {/* Scanner Status Display */}
//         {scannerStatus && scannerStatus.code === '0000' && (
//           <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-2 rounded mb-4 text-sm flex items-center gap-2">
//             <Fingerprint className="w-4 h-4" />
//             <span>Scanner Status: {scannerStatus.message} ✓</span>
//           </div>
//         )}

//         {scannerStatus && scannerStatus.code !== '0000' && (
//           <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded mb-4 text-sm flex items-center gap-2">
//             <AlertCircle className="w-4 h-4" />
//             <span>Scanner Error: {scannerStatus.message}</span>
//           </div>
//         )}

//         <div className="space-y-4">
//           {/* Scanner Animation/Interface */}
//           <div className="bg-gray-100 rounded-lg p-8 flex flex-col items-center justify-center">
//             <div className={`relative ${scanStatus === 'scanning' ? 'animate-pulse' : ''}`}>
//               <Fingerprint className={`w-24 h-24 ${scanStatus === 'success' ? 'text-green-500' :
//                 scanStatus === 'error' ? 'text-red-500' :
//                   scanStatus === 'scanning' ? 'text-[#B03982]' :
//                     'text-gray-400'
//                 }`} />

//               {scanStatus === 'scanning' && (
//                 <div className="absolute -top-2 -right-2">
//                   <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#B03982]"></div>
//                 </div>
//               )}
//             </div>

//             {scanStatus === 'scanning' && (
//               <div className="mt-4 text-center">
//                 <p className="text-gray-600">Scanning fingerprint...</p>
//                 <p className="text-sm text-gray-500 mt-1">Timeout: {countdown}s</p>
//                 <p className="text-xs text-gray-400 mt-2">Attempts remaining: {MAX_SCAN_ATTEMPTS - scanAttempts}</p>
//               </div>
//             )}

//             {scanStatus === 'processing' && (
//               <div className="mt-4 text-center">
//                 <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#B03982] mx-auto"></div>
//                 <p className="mt-2 text-gray-600">Processing fingerprint data...</p>
//               </div>
//             )}

//             {scanStatus === 'success' && (
//               <div className="mt-4 text-center">
//                 <CheckCircle className="w-8 h-8 text-green-500 mx-auto" />
//                 <p className="mt-2 text-green-600 font-medium">
//                   {mode === 'registration' ? 'Fingerprint captured!' : 'Authentication successful!'}
//                 </p>
//               </div>
//             )}

//             {scanStatus === 'error' && (
//               <div className="mt-4 text-center">
//                 <XCircle className="w-8 h-8 text-red-500 mx-auto" />
//                 <p className="mt-2 text-red-600">{errorMessage}</p>
//               </div>
//             )}
//           </div>

//           {/* Action Buttons */}
//           <div className="flex gap-2">
//             {scanStatus === 'idle' && scannerStatus?.code === '0000' && (
//               <Button
//                 onClick={scanFingerprint}
//                 bg="bg-[#B03982]"
//                 className="flex-1 text-white"
//               >
//                 <Fingerprint className="w-4 h-4 mr-2" />
//                 {mode === 'registration' ? 'Start Registration' : 'Start Scan'}
//               </Button>
//             )}
//             {(scanStatus === 'error' || scanStatus === 'success') && (
//               <Button
//                 onClick={handleRetry}
//                 variant="outline"
//                 className="flex-1"
//               >
//                 <RefreshCw className="w-4 h-4 mr-2" />
//                 Scan Again
//               </Button>
//             )}
//             {scanStatus === 'success' && mode === 'login' && onLoginSuccess && (
//               <Button
//                 onClick={handleClose}
//                 bg="bg-[#9A3A84]"
//                 className="flex-1 text-white"
//               >
//                 <LogIn className="w-4 h-4 mr-2" />
//                 Continue
//               </Button>
//             )}
//           </div>

//           {/* Attempts Warning */}
//           {scanAttempts > 0 && scanAttempts < MAX_SCAN_ATTEMPTS && (
//             <p className="text-xs text-amber-600 text-center">
//               {MAX_SCAN_ATTEMPTS - scanAttempts} attempts remaining
//             </p>
//           )}

//           {/* Alternative Options */}
//           <div className="text-center mt-4">
//             <button
//               onClick={handleClose}
//               className="text-sm text-gray-500 hover:text-gray-700"
//             >
//               Cancel and try another method
//             </button>
//           </div>
//         </div>

//         <button
//           onClick={handleClose}
//           className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl"
//           disabled={scanStatus === 'scanning' || scanStatus === 'processing'}
//         >
//           ×
//         </button>
//       </div>
//     </div>
//   );
// };

// export default FingerprintScannerModal2;

import React, { useState, useEffect, useCallback } from 'react';
import { Fingerprint, CheckCircle, XCircle, RefreshCw, LogIn, AlertCircle } from 'lucide-react';
import Button from './button';
import Swal from 'sweetalert2';
import axios from 'axios';

const FingerprintScannerModal2 = ({
  isOpen,
  onClose,
  onScanSuccess,
  onLoginSuccess,
  mode,
}) => {
  const [scannerStatus, setScannerStatus] = useState(null);
  const [scanStatus, setScanStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const [scanAttempts, setScanAttempts] = useState(0);
  const [countdown, setCountdown] = useState(0);

  const BASE_URL = 'http://localhost:9094';
  const MAX_SCAN_ATTEMPTS = 3;
  const SCAN_TIMEOUT = 30; // seconds

  useEffect(() => {
    if (isOpen) {
      checkScannerStatus();
    }
  }, [isOpen]);

  // Countdown timer for scan timeout
  useEffect(() => {
    let timer;
    if (scanStatus === 'scanning' && countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else if (countdown === 0 && scanStatus === 'scanning') {
      handleScanTimeout();
    }
    return () => clearTimeout(timer);
  }, [countdown, scanStatus]);

  const handleClose = useCallback(() => {
    setScanStatus('idle');
    setErrorMessage('');
    setScannerStatus(null);
    setScanAttempts(0);
    setCountdown(0);
    onClose();
  }, [onClose]);

  const handleRegistration = useCallback(async (fingerprintData) => {
    try {
      setScanStatus('processing');

      // Call your backend API to register fingerprint
      const registrationResponse = await axios.post(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/biometric/register`, {
        type: 'FINGERPRINT',
        template: fingerprintData.fingerprintIso || fingerprintData.fingerprintWsq,
        format: fingerprintData.fingerprintIso ? 'ISO' : 'WSQ',
        timestamp: new Date().toISOString()
      },
        {
          headers: {
            "Content-Type": "application/json",
            token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        }
      );

      if (registrationResponse.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Registration Successful',
          text: 'Your fingerprint has been registered successfully!',
          timer: 2000,
          customClass: {
            confirmButton: 'gradient-button'
          }
        });

        onScanSuccess(fingerprintData);
        setTimeout(() => handleClose(), 2000);
      } else {
        throw new Error(registrationResponse.data.message || 'Registration failed');
      }
    } catch (err) {
      console.error('Fingerprint registration error:', err);
      setScanStatus('error');
      setErrorMessage(err.message || 'Failed to register fingerprint. Please try again.');
    }
  }, [handleClose, onScanSuccess]);

  const handleLogin = useCallback(async (fingerprintData) => {
    console.log('fingerprint data ===>', fingerprintData);
    try {
      setScanStatus('processing');
      const loginResponse = await axios.post(`${process.env.REACT_APP_PORTAL_APP_BASE_URL}/fingerprints/identify`,
        { kiosk_response: fingerprintData },
        {
          headers: {
            "Content-Type": "application/json",
            token: `${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
          },
        }
      );
      const loginData = loginResponse.data.data;
      console.log('login response ===>', loginData);

      if (loginResponse.status === 200) {
        const token = loginData.token;

        Swal.fire({
          icon: 'success',
          title: 'Login Successful',
          text: `Welcome back, ${loginData.name || loginData.email || 'User'}!`,
          timer: 2000,
          customClass: {
            confirmButton: 'gradient-button'
          }
        });

        if (onLoginSuccess) {
          console.log('login data ===>', loginData);
          onLoginSuccess(token, loginData);
        }

        onScanSuccess(fingerprintData);
        setTimeout(() => handleClose(), 2000);
      } else {
        throw new Error(loginData.message || 'Authentication failed');
      }
    } catch (err) {
      console.error('Fingerprint login error:', err);
      setScanStatus('error');
      if (err?.status === 401) {
        setErrorMessage('Fingerprint not recognized. Please try again.');
      } else if (err?.status === 404) {
        setErrorMessage('Fingerprint not registered. Please register your fingerprint first.');
      } else {
        setErrorMessage(err.message || 'Failed to scan fingerprint. Please try again.');
      }
    }
  }, [handleClose, onLoginSuccess, onScanSuccess]);

  const checkScannerStatus = async () => {
    try {
      const response = await fetch(`${BASE_URL}/api/hardware/fingerprint-scanner/get-status`, {
        method: 'GET',
        headers: {
          'accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Scanner status check failed: ${response.status}`);
      }

      const data = await response.json();
      setScannerStatus(data);

      if (data.code !== '0000') {
        setErrorMessage(`Scanner error: ${data.message}`);
        setScanStatus('error');
      }
    } catch (err) {
      console.error('Scanner status check error:', err);
      setErrorMessage('Failed to check fingerprint scanner. Please ensure scanner is connected.');
      setScanStatus('error');
    }
  };

  const scanFingerprint = useCallback(async () => {
    if (scanAttempts >= MAX_SCAN_ATTEMPTS) {
      Swal.fire({
        icon: 'warning',
        title: 'Maximum Attempts Reached',
        text: 'Please try again later or use an alternative method.',
        customClass: {
          confirmButton: 'gradient-button'
        }
      });
      handleClose();
      return;
    }
    setScanStatus('scanning');
    setCountdown(SCAN_TIMEOUT);
    setErrorMessage('');
    try {
      const response = await fetch(`${BASE_URL}/api/hardware/fingerprint-scanner/scan`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      // Check for timeout error (code: 9998)
      if (data.code === '9998') {
        setScanAttempts(prev => prev + 1);
        setScanStatus('error');
        setErrorMessage(`Scan timeout. ${MAX_SCAN_ATTEMPTS - (scanAttempts + 1)} attempts remaining.`);
        return;
      }

      // Check for success (code: 0000)
      if (data.code === '0000' && data.data) {
        setScanStatus('success');

        // Handle based on mode
        if (mode === 'registration') {
          // Call registration handler
          await handleRegistration(data.data);
        } else {
          // Call login handler
          await handleLogin(data);
        }
      } else {
        setScanAttempts(prev => prev + 1);
        setScanStatus('error');
        setErrorMessage(`Scan failed: ${data.message || 'Unknown error'}`);
      }

    } catch (err) {
      console.log('err a raha =====>', err);
      setErrorMessage(err.message || 'Failed to scan fingerprint. Please try again.');
      console.error('Fingerprint scan error:', err);
      setScanAttempts(prev => prev + 1);
      setScanStatus('error');
    }
  }, [
    handleClose,
    handleLogin,
    handleRegistration,
    mode,
    scanAttempts
  ]);

  const handleScanTimeout = () => {
    setScanStatus('error');
    setErrorMessage(`Scan timed out after ${SCAN_TIMEOUT} seconds. Please try again.`);
    setScanAttempts(prev => prev + 1);
  };

  useEffect(() => {
    if (isOpen) {
      scanFingerprint();
    }
  }, [isOpen, scanFingerprint]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg p-6 max-w-md w-full relative">
        <h2 className="text-xl font-semibold mb-4 text-[#B03982]">
          {mode === 'registration' ? 'Register Fingerprint' : 'Fingerprint Login'}
        </h2>

        <p className="text-gray-600 mb-4">
          {mode === 'registration'
            ? 'Place your finger on the scanner to register'
            : 'Place your finger on the scanner to log in'
          }
        </p>

        {/* Scanner Status Display */}
        {scannerStatus && scannerStatus.code === '0000' && (
          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-2 rounded mb-4 text-sm flex items-center gap-2">
            <Fingerprint className="w-4 h-4" />
            <span>Scanner Status: {scannerStatus.message} ✓</span>
          </div>
        )}

        {scannerStatus && scannerStatus.code !== '0000' && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-2 rounded mb-4 text-sm flex items-center gap-2">
            <AlertCircle className="w-4 h-4" />
            <span>Scanner Error: {scannerStatus.message}</span>
          </div>
        )}

        <div className="space-y-4">
          {/* Scanner Animation/Interface */}
          <div className="bg-gray-100 rounded-lg p-8 flex flex-col items-center justify-center">
            <div className={`relative ${scanStatus === 'scanning' ? 'animate-pulse' : ''}`}>
              <Fingerprint className={`w-24 h-24 ${scanStatus === 'success' ? 'text-green-500' :
                scanStatus === 'error' ? 'text-red-500' :
                  scanStatus === 'scanning' ? 'text-[#B03982]' :
                    'text-gray-400'
                }`} />

              {scanStatus === 'scanning' && (
                <div className="absolute -top-2 -right-2">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#B03982]"></div>
                </div>
              )}
            </div>

            {scanStatus === 'scanning' && (
              <div className="mt-4 text-center">
                <p className="text-gray-600">Scanning fingerprint...</p>
                <p className="text-sm text-gray-500 mt-1">Timeout: {countdown}s</p>
                <p className="text-xs text-gray-400 mt-2">Attempts remaining: {MAX_SCAN_ATTEMPTS - scanAttempts}</p>
              </div>
            )}

            {scanStatus === 'processing' && (
              <div className="mt-4 text-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#B03982] mx-auto"></div>
                <p className="mt-2 text-gray-600">Processing fingerprint data...</p>
              </div>
            )}

            {scanStatus === 'success' && (
              <div className="mt-4 text-center">
                <CheckCircle className="w-8 h-8 text-green-500 mx-auto" />
                <p className="mt-2 text-green-600 font-medium">
                  {mode === 'registration' ? 'Fingerprint captured!' : 'Authentication successful!'}
                </p>
              </div>
            )}

            {scanStatus === 'error' && (
              <div className="mt-4 text-center">
                <XCircle className="w-8 h-8 text-red-500 mx-auto" />
                <p className="mt-2 text-red-600">{errorMessage}</p>
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div className="gap-2">

            {/* {scanStatus === 'idle' &&
              <>
                <input
                  key={`email-${inputKey}`}
                  ref={emailRef}
                  dir={i18n.language === 'sa' ? 'rtl' : 'ltr'}
                  id="login-email"
                  type="email"
                  inputMode="email"
                  placeholder={t("Enter your email")}
                  value={email}
                  onChange={handleEmailChange}
                  onFocus={handleEmailFocus}
                  className="w-full h-12 px-4 border-2 border-[#B03982] rounded-lg focus:outline-none focus:ring-0 focus:ring-[#B03982]"
                  name="email"
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck="false"
                  readOnly={autofillPrevented.current} // Temporarily make readonly when preventing autofill
                />
              </>
            } */}

            {/* {scanStatus === 'idle' && (
              <Button
                bg='bg-[#9A3A84]'
                variant=""
                className="w-full h-12 mt-4 bg-gradient-to-b from-[#B03982] to-[#733C86] text-white font-semibold rounded-full hover:opacity-90 focus:outline-none"
                onClick={scanFingerprint}
                // disabled={!email}
              >
                Scan
              </Button>
            )} */}

            {(scanStatus === 'error' || scanStatus === 'success') && (
              <Button
                bg='bg-[#9A3A84]'
                variant=""
                className="w-full h-12 mt-4 bg-gradient-to-b from-[#B03982] to-[#733C86] text-white font-semibold rounded-full hover:opacity-90 focus:outline-none"
                onClick={scanFingerprint}
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Scan Again
              </Button>
            )}

            {scanStatus === 'success' && mode === 'login' && onLoginSuccess && (
              <Button
                onClick={handleClose}
                bg="bg-[#9A3A84]"
                className="flex-1 text-white"
              >
                <LogIn className="w-4 h-4 mr-2" />
                Continue
              </Button>
            )}
          </div>

          {/* Attempts Warning */}
          {scanAttempts > 0 && scanAttempts < MAX_SCAN_ATTEMPTS && (
            <p className="text-xs text-amber-600 text-center">
              {MAX_SCAN_ATTEMPTS - scanAttempts} attempts remaining
            </p>
          )}

          {/* Alternative Options */}
          <div className="text-center mt-4">
            <button
              onClick={handleClose}
              className="text-sm text-gray-500 hover:text-gray-700"
            >
              Cancel and try another method
            </button>
          </div>
        </div>

        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl"
        // disabled={scanStatus === 'scanning' || scanStatus === 'processing'}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default FingerprintScannerModal2;